import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Formatea la fecha de un evento tal como la entrega la API: string plano
// "DD-MM-YYYY" (ver ciudad-server PR #104) — nunca un instante real, así que
// se parsea por posición en vez de con `new Date(string)`, que lo
// reinterpretaría como UTC medianoche y correría el día según el huso de
// quien lo lea. Usar en todo lugar donde se muestre `date.start` / `date.end`.
export function formatDateLocal(
  dateStr: string,
  locale = 'es-CL',
  options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' },
): string {
  const ddmmyyyy = /^(\d{2})-(\d{2})-(\d{4})$/.exec(dateStr)
  if (ddmmyyyy) {
    const [, day, month, year] = ddmmyyyy
    return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString(locale, options)
  }
  // Fallback defensivo para strings ISO ("YYYY-MM-DD..."), por si llega un
  // valor que no pasó por la serialización nueva del backend.
  const [year, month, day] = dateStr.slice(0, 10).split('-').map(Number)
  return new Date(year, month - 1, day).toLocaleDateString(locale, options)
}
